
const filters = {
	/**
	 * 功能：s数字格式化
	 * @param {number} num 金额
	 * @returns {string} 格式化后的金额字符串
	 */
	formatAmount: function(num) {
		num = Number(num);
		if (isNaN(num)) return '0';

		if (num < 10000) {
			// 小于1万，显示原数（保留2位小数）
			// return num.toFixed(2);
			return num;
		} else if (num < 10000000) { // 1万 ~ 1000万以下
			const w = Math.floor(num / 10000);
			const remainder = num % 10000;
			return remainder === 0 ? `${w}w` : `${w}w+`;
		} else if (num < 100000000) { // 1000万 ~ 1亿以下（显示 x千万 或 x千万+）
			const tenMillion = Math.floor(num / 10000000);
			const remainder = num % 10000000;
			return remainder === 0 ? `${tenMillion}千万` : `${tenMillion}千万+`;
		} else { // 1亿及以上
			const y = Math.floor(num / 100000000);
			const remainder = num % 100000000;
			return remainder === 0 ? `${y}亿` : `${y}亿+`;
		}
	},
	/**
	 * 功能：读取后三位
	 * @param {Object} num 金额
	 */
	substrUrl: function(num) {
		return Number(num).toFixed(2).substr(-3);
	},
	/**
	 * 功能：定义一个函数来解析查询字符串
	 * @param {Object}
	 */
	parseQueryString(query) {
		const params = {};
		const keyValuePairs = query.split('&');

		keyValuePairs.forEach(pair => {
			const [key, value] = pair.split('=');
			params[decodeURIComponent(key)] = decodeURIComponent(value || '');
		});

		return params;
	},
	/**
	 * 功能：获取视频第一帧
	 * @param {Object} url
	 */
	getVideoThumbnail: function(videoUrl) {
		return new Promise((resolve, reject) => {
			const video = document.createElement('video');
			video.src = videoUrl;

			video.addEventListener('loadeddata', () => {
				// 设置视频的当前时间为 0
				video.currentTime = 0;
			});

			video.addEventListener('seeked', () => {
				// 创建 canvas 以绘制视频帧
				const canvas = document.createElement('canvas');
				canvas.width = video.videoWidth;
				canvas.height = video.videoHeight;
				const context = canvas.getContext('2d');

				// 将视频帧绘制到 canvas 上
				context.drawImage(video, 0, 0, canvas.width, canvas.height);

				// 获取数据 URL
				const thumbnail = canvas.toDataURL('image/png');
				resolve(thumbnail);
			});

			video.addEventListener('error', (err) => {
				reject(err);
			});
		});
	},
	/**
	 * 功能：回显影集
	 * @param {Object} url
	 */
	fullImageArr: function(arr, arrName, keyName, videoName) {
		if (arr == null || !arr.length) {
			return []
		}
		let name = arrName ? arrName : 'albumList'
		let key = keyName ? keyName : 'materialUrl'

		arr.forEach(item => {
			item.removeType = false
			if (item[name].length) {
				item.imgs = item[name].map(n => {
					if (n.type == 1 && videoName) {
						return this.fullImageUrl(n[videoName])
					} else {
						return this.fullImageUrl(n[key])
					}
				})
			} else {
				item.imgs = []
			}
		})
		return arr
	},
	/**
	 * 功能：回显影集-two
	 * @param {Object} url
	 * @param cjx
	 */
	fullImageArrTwo: function(arr, arrName, keyName) {
		if (arr == null || !arr.length) {
			return []
		}
		let name = arrName ? arrName : 'albumList'
		let key = keyName ? keyName : 'materialUrl'
		arr.forEach(item => {
			item.removeType = false
			if (item.albumList.length) {
				item.imgs = item.albumList.map(n => this.fullImageUrl(n.pic))
			} else {
				item.imgs = []
			}
		})
		return arr
	},
	/**
	 * 功能：隐藏手机号
	 * @param {Object}
	 */
	phoneNumShow: function(phone) {
		let number = String(phone)
		let mphone = number.substring(0, 3) + '****' + number.substring(7);
		return mphone
	},
	/**
	 * 手机号格式化
	 * @param {string | number} mobile 手机号
	 * @returns '188 8888 8888'格式的手机号
	 */

	formatMobile: function(mobile) {
		const regMobile = /^1\d{10}/;
		if (!regMobile.test(mobile)) {
			return "";
		}
		return String(mobile).replace(/(^\d{3}|\d{4}\B)/g, "$1 ");
	},
	/**
	 * 金额 千分位
	 * @param { number} mobile 金额
	 * @returns '12,300,000' 金额格式
	 */
	format_with_array(
		number,
		decimals,
		dec_point,
		thousands_sep,
		round_tag
	) {
		number = (number + '').replace(/[^0-9+-Ee.]/g, '')
		decimals = decimals || 2 //默认保留2位
		dec_point = dec_point || '.' //默认是'.';
		thousands_sep = thousands_sep || ',' //默认是',';
		round_tag = round_tag || 'round' //默认是四舍五入
		var n = !isFinite(+number) ? 0 : +number,
			prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
			sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
			dec = typeof dec_point === 'undefined' ? '.' : dec_point,
			s = '',
			toFixedFix = function(n, prec) {
				var k = Math.pow(10, prec)
				console.log()

				return (
					'' +
					parseFloat(
						Math[round_tag](parseFloat((n * k).toFixed(prec * 2))).toFixed(
							prec * 2
						)
					) /
					k
				)
			}
		s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
		var re = /(-?\d+)(\d{3})/
		while (re.test(s[0])) {
			s[0] = s[0].replace(re, '$1' + sep + '$2')
		}
		if ((s[1] || '').length < prec) {
			s[1] = s[1] || ''
			s[1] += new Array(prec - s[1].length + 1).join('0')
		}
		return s.join(dec)
	},
	/**
	 *  空转 -- 
	 * @param {Object} data 金额
	 */
	nullCheck: function(data) {
		let text = data ? data : '--'
		return text;
	},
	/**
	 *  空转 0 
	 * @param {Object} data 金额
	 */
	nullCheckNumder: function(data) {
		let text = data ? data : '0'
		return text;
	},
	/**
	 * 功能：格式化金额展示
	 * @param {Object} data 金额
	 */
	currency: function(data) {
		data = data ? Number(data).toFixed(2) : 0
		if (data == parseInt(data)) {
			data = parseInt(data);
		}
		return data;
	},

	getDateObjects: function(number) {
		const dateObjects = [];
		const dayOfWeekDict = {
			0: "周日",
			1: "周一",
			2: "周二",
			3: "周三",
			4: "周四",
			5: "周五",
			6: "周六"
		};

		for (let i = 0; i < number; i++) {
			const today = new Date();
			const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + i);
			const year = date.getFullYear();
			const month = date.getMonth() + 1;
			const day = date.getDate();
			const dayOfWeek = dayOfWeekDict[date.getDay()];
			dateObjects.push({
				date: year + "-" + month + "-" + day,
				weekday: dayOfWeek
			});
		}
		return dateObjects;
	},

	/**
	 * 功能：拼接完整图片地址
	 * @param {Object} url
	 */
	fullImageUrl: function(url) {
		if (url == null) {
			return ''
		}
		if (url.startsWith('http')) {
			return url;
		}
		return 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/' + url;
	},

	/**
	 * 处理富文本里的图片宽度自适应
	 * 1.去掉img标签里的style、width、height属性
	 * 2.img标签添加style属性：max-width:100%;height:auto
	 * 3.修改所有style里的width属性为max-width:100%
	 * 4.去掉<br/>标签
	 * @param html
	 * @returns {void|string|*}
	 */
	formatRichText(html) { //控制小程序中图片大小
		if (html == null) return ''
		let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
			match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
			match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
			match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
			return match;
		});
		newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
			match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi,
				'max-width:100%;');
			return match;
		});
		newContent = newContent.replace(/<br[^>]*\/>/gi, '');
		newContent = newContent.replace(/\<img/gi,
			'<img style="max-width:100%;height:auto;display:inline-block;margin:0rpx auto;"');
		return newContent;
	},

	safePhone: function(phone) {
		if (phone.length == 11) {
			phone = phone.replace(phone.substring(3, phone.length - 4), '****')
			return phone
		}
		return phone
	},

	prettyPhone: function(phone) {
		if (phone.length == 11) {
			return phone.substring(0, 3) + '  ' + phone.substring(3, 7) + '  ' + phone.substring(7, 11)
		}
		return phone
	},

	enumValueByKey: function(value, enumObj, key = 'desc') {
		var target = ''
		Object.keys(enumObj).forEach(item => {
			const obj = enumObj[item]
			if (obj.value === value) {
				target = obj[key]
			}
		})
		return target
	},
}
export default (Vue) => {
	Object.keys(filters).forEach(key => {
		Vue.filter(key, filters[key])
	})
}


//////////////////
// WEBPACK FOOTER
// ./utils/filter.js
// module id = null
// module chunks = 